import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useScrollToTop from './hooks/useScrollToTop';
import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Qualification from "./pages/Qualification";
import Products from "./pages/Products";
import Authentication from "./pages/Authentication";
import Register from "./pages/Register";
import Contact from "./pages/Contact";

// ScrollToTop component
function ScrollToTop() {
  useScrollToTop();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* Add this BEFORE Routes */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/qualification" element={<Qualification />} />
        <Route path="/products" element={<Products />} />
        <Route path="/authentication" element={<Authentication />} /> {/* lowercase 'a' recommended */}
        <Route path="/register" element={<Register />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );  
}

export default App; 